export const NETWORK_ERROR_RETRY = 2;

export const DEFAULT_RETRY = 1;

export const isNetworkErroFunc = (errMsg: string) => {
  return (
    errMsg.includes("Network Error") ||
    errMsg.includes("timeout") ||
    errMsg.includes("Request aborted")
  );
};
